package one.healthium.log_food.ui.camera

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier

@Composable
actual fun FoodCameraScreen(eventDelegate: FoodCameraEventDelegate) {
    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        Text("Camera is not supported on this platform")
    }
}
